export const jobOperationTypeLabels = {
  EDIT_FIELDS: 'Edit Fields',
  EDIT_GENERAL_INFO: 'Edit General Info',
  EDIT_MEMBERS_AND_RELATIONS: 'Edit Memberships and Relations',
  EDIT_ORGANIZATIONS: 'Edit Organizations',
  IMPORT: 'Object import',
  EXPORT: 'Export objects',
  DELETE: 'Delete objects',
};
